export const getLeaveTypeId = (list, typeName) => {
  let type = "";
  type = list?.filter((el) => el.name === typeName);
  return type[0]._id;
};
